import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import LanguageContext from '../../i18n/LanguageContext';

class CategoryV2 extends Component {

    render() {

        const { t } = this.context;
        let publicUrl = process.env.PUBLIC_URL+'/'
        let imagealt = 'image'

    return <div className="ltn__category-area ltn__product-gutter section-bg-1--- pt-115 pb-70">
			  <div className="container">
			    <div className="row">
			      <div className="col-lg-12">
			        <div className="section-title-area ltn__section-title-2--- text-center">
			          <h6 className="section-subtitle section-subtitle-2--- ltn__secondary-color"></h6>
			          <h1 className="section-title">{t('services.title')}</h1>
			        </div>
			      </div>
			    </div>
			    <div className="row ltn__category-slider-active--- slick-arrow-1 justify-content-center go-top">
			      <div className="col-lg-3 col-md-4 col-sm-6 col-6">
			        <div className="ltn__category-item ltn__category-item-5 ltn__category-item-5-2 text-center---">
			          <Link to="/">
			            <span className="category-icon"><i className="flaticon-car" /></span>
			            <span className="category-number">1</span>
			            <span className="category-title">{t('services.s1Title')}</span>
			            <span className="category-brief">{t('services.s1Text')}</span>
			            <span className="category-btn d-none"><i className="flaticon-right-arrow" /></span>
			          </Link>
			        </div>
			      </div>
			      <div className="col-lg-3 col-md-4 col-sm-6 col-6">
			        <div className="ltn__category-item ltn__category-item-5 ltn__category-item-5-2 text-center---">
			          <Link to="/">
			            <span className="category-icon"><i className="flaticon-swimming" /></span>
			            <span className="category-number">2</span>
			            <span className="category-title">{t('services.s2Title')}</span>
			            <span className="category-brief">{t('services.s2Text')}</span>
			            <span className="category-btn d-none"><i className="flaticon-right-arrow" /></span>
			          </Link>
			        </div>
			      </div>
			      <div className="col-lg-3 col-md-4 col-sm-6 col-6">
			        <div className="ltn__category-item ltn__category-item-5 ltn__category-item-5-2 text-center---">
			          <Link to="/">
			            <span className="category-icon"><i className="flaticon-secure-shield" /></span>
			            <span className="category-number">3</span>
			            <span className="category-title">{t('services.s3Title')}</span>
			            <span className="category-brief">{t('services.s3Text')}</span>
			            <span className="category-btn d-none"><i className="flaticon-right-arrow" /></span>
			          </Link>
			        </div>
			      </div>


			      <div className="col-lg-3 col-md-4 col-sm-6 col-6">
			        <div className="ltn__category-item ltn__category-item-5 ltn__category-item-5-2 text-center---">
			          <Link to="/">
			            <span className="category-icon"><i className="flaticon-bed-1" /></span>
			            <span className="category-number">4</span>
			            <span className="category-title">{t('services.s4Title')}</span>
			            <span className="category-brief">{t('services.s4Text')}</span>
			            <span className="category-btn d-none"><i className="flaticon-right-arrow" /></span>
			          </Link>
			        </div>
			      </div>
			    </div>
			  </div>
			</div>

        }
}

CategoryV2.contextType = LanguageContext;

export default CategoryV2
